import { useState } from 'react'

import app from 'config/firebase'

import {
  addDoc,
  collection,
  deleteDoc,
  deleteField,
  doc,
  getDoc,
  // getDocs,
  getFirestore,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  // updateDoc,
  where
} from 'firebase/firestore'

// import {
//   // getDownloadURL,
//   // getStorage,
//   // ref,
//   // uploadBytes
// } from 'firebase/storage'

const db = getFirestore(app)
// const storage = getStorage(app)

export const useProvideFirestore = () => {
  const [user, setUser] = useState()
  const [director, setDirector] = useState()
  const [directors, setDirectors] = useState()
  const [parent, setParent] = useState()
  const [parents, setParents] = useState()
  const [preceptor, setPreceptor] = useState()
  const [preceptors, setPreceptors] = useState()
  const [schools, setSchools] = useState()
  const [school, setSchool] = useState()
  const [student, setStudent] = useState()
  const [students, setStudents] = useState()
  const [virtues, setVirtues] = useState()
  const [goals, setGoals] = useState()
  const [agreements, setAgreements] = useState()

  const clean = () => {
    setUser(undefined)
    setDirector(undefined)
    setDirectors(undefined)
    setParent(undefined)
    setParents(undefined)
    setPreceptor(undefined)
    setPreceptors(undefined)
    setSchools(undefined)
    setSchool(undefined)
    setStudent(undefined)
    setStudents(undefined)
    setVirtues(undefined)
    setGoals(undefined)
    setAgreements(undefined)
  }
  
  const createProfile = async (uid, user) => {
    const docRef = doc(db, 'users', uid)
    const docSnap = await getDoc(docRef)
    
    if (!docSnap.exists()) {
      user['createdAt'] = serverTimestamp()
      user['updatedAt'] = serverTimestamp()
      user['role'] = 'user'
      user['uid'] = uid
      await setDoc(docRef, user)
    }
  }

  const updateProfile = async (uid, data) => {
    const docRef = doc(db, 'users', uid)

    data['updatedAt'] = serverTimestamp()

    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      await updateDoc(docRef, data)
    }
  }

  const getProfile = async (uid) => {
    const docRef = doc(db, 'users', uid)
    onSnapshot(docRef, doc => {
      setUser(doc.data())
    })
  }

  const getSchools = () => {
    const schoolsRef = collection(db, 'schools')
    onSnapshot(schoolsRef, (querySnapshot) => {
      const schools = []
      querySnapshot.forEach(async (snapDoc) => {
        const school = snapDoc.data()
        school['id'] = snapDoc.id
        schools.push(school)
        // MIGRATION
        // const levels = Object.keys(school.levels)
        // const stages = []
        // levels.forEach((key) => {
        //   const level = school.levels[key]
        //   if (level) {
        //     stages.push(key)
        //   }
        // })
        // const docRef = doc(db, 'schools', snapDoc.id)
        // await updateDoc(docRef, {
        //   'stages': stages
        // })
      })
      setSchools(schools)
    })
  }

  const getSchool = (id) => {
    const docRef = doc(db, 'schools', id)
    onSnapshot(docRef, (doc) => {
      setSchool(doc.data())
    })
  }

  const getPreceptorsBySchoolId = (schoolId) => {
    const preceptorsRef = collection(db, 'preceptors')

    const q = query(preceptorsRef, where('schoolId', '==', schoolId))

    onSnapshot(q, (querySnapshot) => {
      const preceptors = []
      querySnapshot.forEach((doc) => {
        const preceptor = doc.data()
        preceptor['id'] = doc.id
        preceptors.push(preceptor)
      })
      setPreceptors(preceptors)
    })
  }

  const getStudentsBySchoolId = (schoolId) => {
    const studentsRef = collection(db, 'students')

    const q = query(studentsRef, where('schoolId', '==', schoolId))

    onSnapshot(q, (querySnapshot) => {
      const students = []
      querySnapshot.forEach((doc) => {
        const student = doc.data()
        student['id'] = doc.id
        students.push(student)
      })
      setStudents(students)
    })
  }

  const getParentsBySchoolId = (schoolId) => {
    const parentsRef = collection(db, 'parents')

    const q = query(parentsRef, where('schoolId', '==', schoolId))

    onSnapshot(q, (querySnapshot) => {
      const parents = []
      querySnapshot.forEach((doc) => {
        const parent = doc.data()
        parent['id'] = doc.id
        parents.push(parent)
      })
      setParents(parents)
    })
  }

  const getDirectorsBySchoolId = (schoolId) => {
    const directorsRef = collection(db, 'directors')

    const q = query(directorsRef, where('schoolId', '==', schoolId))

    onSnapshot(q, (querySnapshot) => {
      const directors = []
      querySnapshot.forEach((doc) => {
        const director = doc.data()
        director['id'] = doc.id
        directors.push(director)
      })
      setDirectors()
    })
  }

  const getVirtues = () => {
    const virtuesRef = collection(db, 'virtues')
    onSnapshot(virtuesRef, (querySnapshot) => {
      const virtues = []
      querySnapshot.forEach((doc) => {
        const virtue = doc.data()
        virtue['id'] = doc.id
        virtues.push(virtue)
      })
      setVirtues(virtues)
    })
  }

  const getGoals = () => {
    const goalsRef = collection(db, 'goals')
    onSnapshot(goalsRef, (querySnapshot) => {
      const goals = []
      querySnapshot.forEach((doc) => {
        const goal = doc.data()
        goal['id'] = doc.id
        goals.push(goal)
      })
      setGoals(goals)
    })
  }

  const getAgreements = () => {
    const agreementsRef = collection(db, 'agreements')
    onSnapshot(agreementsRef, (querySnapshot) => {
      const agreements = []
      querySnapshot.forEach((doc) => {
        const agreement = doc.data()
        agreement['id'] = doc.id
        agreements.push(agreement)
      })
      setAgreements(agreements)
    })
  }

  const getGoalsBySchoolId = (schoolId) => {
    const goalsRef = collection(db, 'goals')

    const q = query(goalsRef, where('schoolId', '==', schoolId))

    onSnapshot(q, (querySnapshot) => {
      const goals = []
      querySnapshot.forEach((doc) => {
        const goal = doc.data()
        goal['id'] = doc.id
        goals.push(goal)
      })
      setGoals(goals)
    })
  }

  const getDirector = (id) => {
    const docRef = doc(db, 'directors', id)
    onSnapshot(docRef, (doc) => {
      setDirector(doc.data())
    })
  }

  const getStudent = (id) => {
    setStudent(undefined)
    const docRef = doc(db, 'students', id)
    onSnapshot(docRef, (doc) => {
      const student = doc.data()
      student['id'] = doc.id
      setStudent(student)
    })
  }

  const getPreceptor = (id) => {
    const docRef = doc(db, 'preceptors', id)
    onSnapshot(docRef, (doc) => {
      const preceptor = doc.data()
      preceptor['id'] = doc.id
      setPreceptor(preceptor)
    })
  }

  const getParent = (id) => {
    const docRef = doc(db, 'parents', id)
    onSnapshot(docRef, (doc) => {
      const parent = doc.data()
      parent['id'] = doc.id
      setParent(parent)
    })
  }

  const addDocToCollection = async (name, data) => {
    const colRef = collection(db, name)

    data['createdAt'] = serverTimestamp()
    data['updatedAt'] = serverTimestamp()

    const doc = await addDoc(colRef, data)
    return doc.id
  }

  const updateDocFromCollection = async (name, id, data) => {
    const docRef = doc(db, name, id)

    data['updatedAt'] = serverTimestamp()

    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      await updateDoc(docRef, data)
    }
  }

  const deleteDocFromCollection = async (name, id) => {
    await deleteDoc(doc(db, name, id))
  }

  const addPreceptorToStudent = async (studentId, preceptor) => {
    updateDocFromCollection('students', studentId, {
      'preceptor': preceptor,
      'preceptorId': preceptor.id,
    })
  }

  const removePreceptorFromStudent = async (studentId) => {
    updateDocFromCollection('students', studentId, {
      'preceptor': deleteField(),
      'preceptorId': deleteField()
    })
  }

  return {
    clean,
    addDocToCollection,
    addPreceptorToStudent,
    agreements,
    createProfile,
    deleteDocFromCollection,
    director,
    directors,
    getAgreements,
    getDirector,
    getDirectorsBySchoolId,
    getGoals,
    getGoalsBySchoolId,
    getParent,
    getParentsBySchoolId,
    getPreceptor,
    getPreceptorsBySchoolId,
    getProfile,
    getSchool,
    getSchools,
    getStudent,
    getStudentsBySchoolId,
    getVirtues,
    goals,
    parent,
    parents,
    preceptor,
    preceptors,
    removePreceptorFromStudent,
    school,
    schools,
    student,
    students,
    updateDocFromCollection,
    updateProfile,
    user,
    virtues,
  }
}